import { baseApi } from '@ibk/shared-config';
export const personAccessApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getPersonAccesses: builder.query({
            query: () => '/v1/person-accesses?requires-account=false',
            providesTags: ['PersonAccess'],
        }),
    }),
});
export const { useGetPersonAccessesQuery, useLazyGetPersonAccessesQuery } = personAccessApi;
